import { useEffect } from 'react';

const SITE_NAME = 'NimbleCasa';
const DEFAULT_TITLE = 'NimbleCasa — Premium Real Estate in Lagos';
const ORIGIN = 'https://www.nimblecasa.com';

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Per-route document head. Runtime only (no SSR) — enough for browsers and
 * JS-executing crawlers. A build-time prerender step can layer real static
 * meta on top of this later without changing callers.
 */
export default function Seo({ title, description, image, path }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title}`.includes(SITE_NAME)
        ? title
        : `${title} | ${SITE_NAME}`
      : DEFAULT_TITLE;
    document.title = fullTitle;

    const url = path ? `${ORIGIN}${path}` : ORIGIN + window.location.pathname;
    const img = image ? (image.startsWith('http') ? image : ORIGIN + image) : `${ORIGIN}/new_project.jpg`;

    setMeta('name', 'description', description);
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', img);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', img);
    setLink('canonical', url);

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description, image, path]);

  return null;
}
